import Axios from 'axios';
import {
  IFAQ,
  IFAQResponse,
  IEligibilityQuizResponse,
  IHardshipEventListResponse,
  ICreateHardshipEventRequest,
  IAppendHardshipDocumentsResponse,
  IAppendHardshipDocumentsRequest,
  ICreateHardshipEventResponse,
  IHFRResponse,
  HFR,
  ICreateGrantRequest,
  IGrantRequestListReponse,
  ICreateGrantResponse,
  IAppendHardshipGrantsRequest,
  IGrantRequestDetailsResponse,
  IAppendHardshipGrantsResponse,
  HardshipTreeData,
  IGrantApplicationsResponse,
  CommunicationPreferenceResponse,
  HardshipDataResponse,
  IHardshipDocumentsResponse,
  ISaveGrantRequestPayload,
  ValidateEmailResp,
  ValidateCodeResp,
  CommPreferenceSaveResponse,
  IFundDetails,
  IReviewerHEResponse,
  IReviewerDBResponse,
  ApplicationDetailsResponse,
  IReviewerApplicationDetails,
  ApplicantInfoReviewerResponse,
  IReviewerPaymentDetailsResponse,
  ISaveReviewerHardshipRequest,
  ISaveReviewerHardshipResponse,
  ISaveReviewerGrantResponse,
  IReviewerGrantDetailsResponse,
  ISaveReviewerGrantRequest,
  ReviewerAssignButtonStatus,
  AssignUnassignResponse,
  ReviewSubmitApplicationRequest,
  ApproveGrantPayload,
  HardshipFiles,
  GrantFiles,
  ReviewerApplicationLogsResponse,
  ActivityLogExportResponse,
  IHardshipEventDetails,
  IReviewerRejectApplicationPayload,
  IAssociateApplicationDetailsResponse,
  IAvailableReviewers,
  IReviewerDashboardFilter,
  IAssociateApplicationProgress,
  SavingsConfiguration,
  IAdminHardshipNodeDocumentsList,
  IAdminHardshipNodeGrantsList,
  DownloadAdminFiles,
  ISaveGrantRequestDisasterPayload,
  IPreliminaryDisasterResponseArr,
  IDisasterCountyList,
  ICountyByStatePayload,
  ISaveDisasterEventPayload,
  IGetAllDisastesDataArr,
  IAdminExcelExportPayload,
  IAcntApplicationCountMetrics,
  IPaymentStatusMetrics,
  MetricsData,
  IAdminD2CExportPayload,
  IAdminReconExportPayload,
  IAdminOutstandingExportPayload,
  SavedFiltersInputs,
  InternalComments,
  FetchInternalComments,
  FetchSavedFilters,
  DefaultFilter,
  IFeatureGetFlag,
  FeedbackInput,
  ClassificationFeedbackInput,
  DocumentFeedbackInput,
  EligibilityQuizApplication,
  AutoAssignResponse,
} from './types/serviceTypes';
import config from './config/config';
import { GrantType } from './constants';
import { cleanupPrefixFromApplicationId } from './utils';

export interface ACNTServiceType {
  userPreliminaryCheck: ({ queryKey }: any) => Promise<IEligibilityQuizResponse>;
  eligibilityQuizCheck: (data: any) => Promise<IEligibilityQuizResponse>;
  getAllActiveFaq: () => Promise<IFAQResponse>;
  disasterPreliminaryCheck: () => Promise<IPreliminaryDisasterResponseArr>;
  getAllFaq: () => Promise<IFAQResponse>;
  saveFaq: (data: any) => Promise<IFAQ>;
  updateFaq: (data: IFAQ) => Promise<IFAQ>;
  deleteFaq: (data: IFAQ) => Promise<IFAQ>;
  getHardshipTreeData: ({ queryKey }: any) => Promise<HardshipTreeData>;
  savingAndIncomeForGrantUi: (data: any) => Promise<IEligibilityQuizResponse>;
  getAllText: () => Promise<IHFRResponse>;
  getAllActiveText: () => Promise<IHFRResponse>;
  saveHFR: (data: any) => Promise<HFR>;
  updateHFR: (data: HFR) => Promise<HFR>;
  deleteHFR: (data: HFR) => Promise<HFR>;
  getAllHardshipEvents: (grantType?: GrantType) => Promise<IHardshipEventListResponse>;
  createHardshipEvent: (data: ICreateHardshipEventRequest) => Promise<ICreateHardshipEventResponse>;
  updateHardshipEvent: (payload: {
    data: ICreateHardshipEventRequest;
    eventId: string;
  }) => Promise<ICreateHardshipEventResponse>;
  getAdminHardshipEventDocuments: (eventId: string) => Promise<IAdminHardshipNodeDocumentsList>;
  getAdminHardshipEventGrants: (eventId: string) => Promise<IAdminHardshipNodeGrantsList>;
  appendHardshipDocuments: (request: {
    data: IAppendHardshipDocumentsRequest;
    eventId: string;
  }) => Promise<IAppendHardshipDocumentsResponse>;
  getHardshipEventDetails: (hardshipEventId: string) => Promise<HardshipTreeData>;
  getAllGrantRequest: () => Promise<IGrantRequestListReponse>;
  createGrantRequest: (data: ICreateGrantRequest) => Promise<ICreateGrantResponse>;
  updateGrantRequest: (payload: {
    data: ICreateGrantRequest;
    grantId: string;
  }) => Promise<ICreateHardshipEventResponse>;
  appendHardshipGrants: (payload: {
    data: IAppendHardshipGrantsRequest;
    hardshipId: string;
  }) => Promise<IAppendHardshipGrantsResponse>;
  getAllGrants: (grantType: GrantType) => Promise<IGrantApplicationsResponse>;
  getHardshipGrantRequest: (payload: { hardshipId: string; questionId: string }) => Promise<IGrantRequestListReponse>;
  getGrantRequestDetails: (grantId: string) => Promise<IGrantRequestDetailsResponse>;
  expenseForGrantUi: (data: any) => Promise<IEligibilityQuizResponse>;
  paymentForGrantUi: (data: any) => Promise<IEligibilityQuizResponse>;
  getAllHardshipData: () => Promise<HardshipDataResponse>;
  getHardshipEventDocuments: (payload: { eventId: string; questionId: string }) => Promise<IHardshipDocumentsResponse>;
  documentUpload: (data: any) => Promise<any>;
  documentDelete: (data: any) => Promise<any>;
  documentDeleteAll: (data: any) => Promise<any>;
  checkValidDocuments: (applicationId: any) => Promise<any>;
  getReviewerAgentResponse: ({ queryKey }: any) => Promise<any>;
  saveRuleFeedback: (feedbackInput: FeedbackInput) => Promise<any>;
  saveLanguageSelection: (language: string) => Promise<any>;
  documentClassification: (documentId: any) => Promise<any>;
  getDocumentClassifications: ({ queryKey }: any) => Promise<any>;
  saveClassificationFeedback: (classificationFeedbackInput: ClassificationFeedbackInput) => Promise<any>;
  getDocumentFeedback: ({ queryKey }: any) => Promise<any>;
  saveDocumentFeedback: (documentFeedbackInput: DocumentFeedbackInput) => Promise<any>;
  saveHardship: (data: any) => Promise<any>;
  saveApplicationGrantRequestDetails: (payload: Array<string | ISaveGrantRequestPayload>) => Promise<unknown>;
  getUserDetails: () => Promise<CommunicationPreferenceResponse>;
  validateEmail: (data: ValidateEmailResp) => Promise<ValidateEmailResp>;
  generateEmailCode: (data: ValidateCodeResp) => Promise<ValidateCodeResp>;
  resendEmailCode: (data: ValidateCodeResp) => Promise<ValidateCodeResp>;
  submitCommunicationPreference: (data: CommPreferenceSaveResponse) => Promise<CommPreferenceSaveResponse>;
  updateSMSNotification: (value: boolean) => Promise<string>;
  fundDetails: () => Promise<IFundDetails>;
  getApplicationStatus: ({ queryKey }: any) => Promise<EligibilityQuizApplication>;
  getApplicationDetails: ({ queryKey }: any) => Promise<ApplicationDetailsResponse>;
  getAssociateApplicationDetails: (applicationId?: string) => Promise<IAssociateApplicationDetailsResponse>;
  getLoggedInUserDetails: () => Promise<string>;
  getReviewerHardshipData: ({ queryKey }: any) => Promise<IReviewerHEResponse>;
  getReviewerPaymentDetails: (applicationId: string) => Promise<IReviewerPaymentDetailsResponse>;
  reviewerDashboard: (data: IReviewerDashboardFilter) => Promise<IReviewerDBResponse>;
  getReviewerApplicationDetails: ({ queryKey }: any) => Promise<IReviewerApplicationDetails>;
  applicantInfoReviewer: ({ queryKey }: any) => Promise<ApplicantInfoReviewerResponse>;
  getReviewerGrantDetails: ({ queryKey }: any) => Promise<IReviewerGrantDetailsResponse>;
  saveReviewerHardshipDetails: (payload: ISaveReviewerHardshipRequest) => Promise<ISaveReviewerHardshipResponse>;
  saveReviewerGrantpDetails: (payload: ISaveReviewerGrantRequest) => Promise<ISaveReviewerGrantResponse>;
  assignButtonStatusReviewer: ({ queryKey }: any) => Promise<ReviewerAssignButtonStatus>;
  autoAssign: () => Promise<AutoAssignResponse>;
  assignToMe: (data: any) => Promise<AssignUnassignResponse>;
  unassignToMe: (data: any) => Promise<AssignUnassignResponse>;
  reviewSubmitApplication: (data: ReviewSubmitApplicationRequest) => Promise<string>;
  approveButtonCheck: ({ queryKey }: any) => Promise<boolean>;
  rejectButtonCheck: ({ queryKey }: any) => Promise<boolean>;
  cancelReturnButtonCheck: ({ queryKey }: any) => Promise<boolean>;
  cancelDeclineButtonCheck: ({ queryKey }: any) => Promise<boolean>;
  approveGrantRequest: (payload: ApproveGrantPayload) => Promise<boolean>;
  getDocsForHardship: ({ queryKey }: any) => Promise<Array<HardshipFiles>>;
  getDocsForGrant: ({ queryKey }: any) => Promise<Array<GrantFiles>>;
  getViewLogs: ({ queryKey }: any) => Promise<ReviewerApplicationLogsResponse>;
  exportActivityLog: (applicationId: string) => Promise<ActivityLogExportResponse>;
  getViewLogsAssociate: ({ queryKey }: any) => Promise<Array<any>>;
  getCommunicationContent: (communicationId: string) => Promise<any>;
  getApplicantHardshipEventDetails: ({ queryKey }: any) => Promise<IHardshipEventDetails>;
  reviewerRejectApplication: (payload: IReviewerRejectApplicationPayload) => Promise<boolean>;
  getAvailableReviewers: () => Promise<IAvailableReviewers>;
  getAssociateApplicationProgress: (applicationId: string) => Promise<Array<IAssociateApplicationProgress>>;
  returnApplicationToApplicant: (data: { applicationId?: string }) => Promise<boolean>;
  downloadReviewerDashboard: (data: IReviewerDashboardFilter) => Promise<void>;
  getReviewerValidActions: ({ queryKey }: any) => Promise<Array<string>>;
  cancelAssociateApplication: (applicationId: string) => Promise<boolean>;
  getSavingsConfiguration: () => Promise<SavingsConfiguration>;
  getSavedFilters: () => Promise<FetchSavedFilters[]>;
  setSavedFilters: (filters: SavedFiltersInputs) => Promise<SavedFiltersInputs>;
  deleteFilters: (filterId: string) => Promise<any>;
  updateDefaultFilter: (data: DefaultFilter) => Promise<DefaultFilter>;
  getInternalComments: (applicationId: string | undefined) => Promise<Array<FetchInternalComments>>;
  setInternalComments: (internalCommentsInput: InternalComments) => Promise<InternalComments>;
  downloadAssociateFiles: (params: { applicationId: number; documentId: string }) => Promise<File>;
  downloadReviewerFiles: (params: { documentId: string }) => Promise<File>;
  downloadHardshipAdminFiles: (params: DownloadAdminFiles) => Promise<File>;
  downloadGrantAdminFiles: (params: DownloadAdminFiles) => Promise<File>;
  resetHardshipGrants: (data: { applicationId: string }) => Promise<boolean>;
  resetGrantDocuments: (data: { applicationId: string; grantId: string }) => Promise<boolean>;
  disasterConfiguredAmount: () => Promise<number>;
  disasterCountyListByStateCode: (data: ICountyByStatePayload) => Promise<IDisasterCountyList>;
  saveDisasterEvent: (data: ISaveDisasterEventPayload) => Promise<string>;
  addDisasterCounty: (data: ISaveDisasterEventPayload) => Promise<string>;
  saveApplicationGrantRequestDisasterDetails: (payload: ISaveGrantRequestDisasterPayload) => Promise<string>;
  saveExitApplicationGrantRequestDisasterDetails: (payload: ISaveGrantRequestDisasterPayload) => Promise<string>;
  getAllDisastersData: () => Promise<IGetAllDisastesDataArr>;
  generateExcelReportAdmin: (data: IAdminExcelExportPayload) => Promise<File>;
  ApplicationCountMetrics: (data: MetricsData) => Promise<IAcntApplicationCountMetrics>;
  ResubmittedApplicationCount: (data: MetricsData) => Promise<number>;
  PaymentStatusCount: (data: MetricsData) => Promise<IPaymentStatusMetrics>;
  AllActiveUser: (data: MetricsData) => Promise<number>;
  generateD2CReportAdmin: (data: IAdminD2CExportPayload) => Promise<string>;
  generateReconReportAdmin: (data: IAdminReconExportPayload) => Promise<string>;
  generateOutstandingReportAdmin: (data: IAdminOutstandingExportPayload) => Promise<string>;
  cancelReturn: (data: any) => Promise<boolean>;
  cancelDecline: (data: any) => Promise<boolean>;
  GetFeatureFlagDetails: () => Promise<IFeatureGetFlag>;
}

const exceptionHandler = (error: any): never => {
  throw error;
};

const ACNTService: ACNTServiceType = {
  userPreliminaryCheck: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/userPreliminaryCheck`, {
      params: { activeApplicationId: modifiedAppId },
    })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  eligibilityQuizCheck: (data: any) => {
    return Axios.post(`${config.appBaseUrl}/eligibilityQuizCheck`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllActiveFaq: () => {
    return Axios.get(`${config.appBaseUrl}/faq/getAllActiveFaq`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  disasterPreliminaryCheck: () => {
    return Axios.get(`${config.appBaseUrl}/associate/disaster-application/preliminary-check`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllFaq: () => {
    return Axios.get(`${config.appBaseUrl}/faq/getAll`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveFaq: (data: any) => {
    return Axios.post(`${config.appBaseUrl}/faq/saveFaq`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  updateFaq: (data: IFAQ) => {
    return Axios.post(`${config.appBaseUrl}/faq/updateFaq`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  deleteFaq: (data: IFAQ) => {
    return Axios.delete(`${config.appBaseUrl}/faq/deleteFaq?id=${data.id}`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllText: () => {
    return Axios.get(`${config.appBaseUrl}/helpfulresources/getAll`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllActiveText: () => {
    return Axios.get(`${config.appBaseUrl}/helpfulresources/getAllActive`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveHFR: (data: any) => {
    return Axios.post(`${config.appBaseUrl}/helpfulresources/save`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  updateHFR: (data: HFR) => {
    return Axios.post(`${config.appBaseUrl}/helpfulresources/update`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  deleteHFR: (data: HFR) => {
    return Axios.delete(`${config.appBaseUrl}/helpfulresources/delete?id=${data.id}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllHardshipEvents: (grantType) => {
    return Axios.get(`${config.appBaseUrl}/all/hardship/events`, { params: { grantType } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getHardshipTreeData: ({ queryKey }: any = { queryKey: [] }) => {
    return Axios.get(`${config.appBaseUrl}/hardship/event?hardshipEventId=${queryKey[1]?.eventId}`)
      .then((response) => response.data.adminHardshipEvent)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  createHardshipEvent: (data) => {
    return Axios.post(`${config.appBaseUrl}/create/hardship/event`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  updateHardshipEvent: ({ data, eventId }) => {
    return Axios.put(`${config.appBaseUrl}/hardship`, data, { params: { hardshipId: eventId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAdminHardshipEventDocuments: (eventId) => {
    return Axios.get(`${config.appBaseUrl}/hardship/configured-documents`, { params: { hardshipId: eventId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAdminHardshipEventGrants: (eventId) => {
    return Axios.get(`${config.appBaseUrl}/hardship/configured-grants`, { params: { hardshipId: eventId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  appendHardshipDocuments: ({ data, eventId }) => {
    return Axios.put(`${config.appBaseUrl}/update/document/details`, data, {
      params: { eventId },
    })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getHardshipEventDetails: (hardshipEventId) => {
    return Axios.get(`${config.appBaseUrl}/hardship/event`, {
      params: { hardshipEventId },
    })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllGrantRequest: () => {
    return Axios.get(`${config.appBaseUrl}/all/grant/details`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  createGrantRequest: (data) => {
    return Axios.post(`${config.appBaseUrl}/create/grant/request`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  updateGrantRequest: ({ data, grantId }) => {
    return Axios.put(`${config.appBaseUrl}/grant`, data, { params: { grantId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  appendHardshipGrants: ({ data, hardshipId }) => {
    return Axios.post(`${config.appBaseUrl}/create/hardship/grant`, data, { params: { hardshipId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getHardshipGrantRequest: ({ hardshipId, questionId }) => {
    return Axios.get(`${config.appBaseUrl}/get/hardship/grant/details`, { params: { hardshipId, questionId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getGrantRequestDetails: (grantId: string) => {
    return Axios.get(`${config.appBaseUrl}/grant/details`, { params: { grantId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveApplicationGrantRequestDetails: (payload) => {
    const [applicationId, data] = payload;
    return Axios.post(`${config.appBaseUrl}/associate/application/grant/details`, data, { params: { applicationId } })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  savingAndIncomeForGrantUi: (data: any) => {
    return Axios.post(`${config.appBaseUrl}/associate/application/saving-and-income`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  expenseForGrantUi: (data: any) => {
    return Axios.put(`${config.appBaseUrl}/associate/application/expenses`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllGrants: (grantType) => {
    return Axios.get(`${config.appBaseUrl}/associate/application/all?grantType=${grantType}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  paymentForGrantUi: (data: any) => {
    return Axios.post(`${config.appBaseUrl}/associate/application/payment`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getUserDetails: () => {
    return Axios.get(`${config.appBaseUrl}/get-user-details`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  validateEmail: (data: ValidateEmailResp) => {
    return Axios.post(`${config.appBaseUrl}/associate/communicationPreferences/validate`, {
      modeValue: data.modeVal.replace(/\s+/g, ''),
      token: data.validationCode,
      mode: data.mode,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  generateEmailCode: (data: ValidateCodeResp) => {
    return Axios.post(`${config.appBaseUrl}/associate/communicationPreferences/generateCode`, {
      ...(data.mode === 'EMAIL' && { EMAIL: data.modeVal }),
      ...(data.mode === 'PHONE' && { PHONE: data.modeVal }),
    })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  resendEmailCode: (data: ValidateCodeResp) => {
    return Axios.get(`${config.appBaseUrl}/associate/communicationPreferences/resendCode`, {
      params: { modeValue: data.modeVal, mode: data.mode },
    })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  submitCommunicationPreference: (data: CommPreferenceSaveResponse) => {
    return Axios.post(`${config.appBaseUrl}/associate/communicationPreferences`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  updateSMSNotification: (value: boolean) => {
    return Axios.post(
      `${config.appBaseUrl}/associate/communicationPreferences/updateSMSNotification?optMobileNotifications=${value}`,
      {}
    )
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllHardshipData: () => {
    return Axios.get(`${config.appBaseUrl}/all/hardship/events`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getHardshipEventDocuments: ({ eventId, questionId }) => {
    return Axios.get(`${config.appBaseUrl}/get/document/details`, {
      params: { eventId, questionId },
    })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  documentUpload: (data: any) => {
    const payload = new FormData();
    const fileData = data[1];
    payload.append('file', fileData);
    return Axios.post(`${config.appBaseUrl}/associate/application/documents/upload`, payload, {
      params: {
        applicationId: data[0],
        fileType: data[2],
        groupId: data[3],
        fileTypeId: data[4],
        fileId: data[5],
        fileTypeChildId: data[6],
      },
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  documentDelete: (data: any) => {
    return Axios.delete(`${config.appBaseUrl}/associate/application/documents`, {
      params: { documentId: data[1] },
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  documentDeleteAll: (data: any) => {
    return Axios.delete(`${config.appBaseUrl}/associate/application/documents/all`, {
      params: { applicationId: data[0], fileType: data[1], groupId: data[2] },
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  checkValidDocuments: (applicationId: any) => {
    return Axios.get(
      `${config.appBaseUrl}/associate/application/documents/check-valid-documents?applicationId=${applicationId}`
    )
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getReviewerAgentResponse: ({ queryKey }) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/fetch-review-summary?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveRuleFeedback: (feedbackInput: any) => {
    return Axios.post(`${config.appBaseUrl}/associate/application/documents/feedback/rule`, feedbackInput)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveLanguageSelection: (language: string) => {
    return Axios.post(`${config.appBaseUrl}/language/post-user-selection`, { language })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  documentClassification: (documentId: any) => {
    return Axios.post(`${config.appBaseUrl}/associate/application/documents/classification`, documentId)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getDocumentClassifications: ({ queryKey }) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/fetch-classification?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveClassificationFeedback: (classificationFeedbackInput: any) => {
    return Axios.post(`${config.appBaseUrl}/reviewer/corrected-classification`, classificationFeedbackInput)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getDocumentFeedback: ({ queryKey }) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/fetch-document-feedback?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveDocumentFeedback: (documentFeedbackInput: any) => {
    return Axios.post(`${config.appBaseUrl}/reviewer/document-feedback`, documentFeedbackInput)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveHardship: (data: any) => {
    return Axios.post(`${config.appBaseUrl}/associate/application/hardship/details`, data[1], {
      params: { applicationId: data[0] },
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  fundDetails: () => {
    return Axios.get(`${config.appBaseUrl}/associate/application/allocated-and-remaining-funds`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getApplicationStatus: ({ queryKey }: any) => {
    const applicationId = queryKey[1].applicationId;
    return Axios.get(`${config.appBaseUrl}/getApplicationStatus?activeApplicationId=${applicationId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getApplicationDetails: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/associate/application?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAssociateApplicationDetails: (applicationId: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.get(`${config.appBaseUrl}/associate/application/details?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getLoggedInUserDetails: () => {
    return Axios.get(`${config.appBaseUrl}/associate/application/user-name`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getReviewerHardshipData: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].appId);
    return Axios.get(`${config.appBaseUrl}/reviewer/hardship?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  reviewerDashboard: (data: IReviewerDashboardFilter) => {
    return Axios.post(`${config.appBaseUrl}/reviewer/dashboard`, data)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getReviewerApplicationDetails: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/applicant/application?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getReviewerPaymentDetails: (applicationId: string) => {
    return Axios.get(`${config.appBaseUrl}/reviewer/applicant/payment/details`, { params: { applicationId } })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  applicantInfoReviewer: ({ queryKey }) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/application/applicantInfo?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getReviewerGrantDetails: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/grant?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveReviewerHardshipDetails: ({ applicationId, data }: ISaveReviewerHardshipRequest) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.post(`${config.appBaseUrl}/reviewer/hardship?applicationId=${modifiedAppId}`, data)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveReviewerGrantpDetails: ({ applicationId, data }: ISaveReviewerGrantRequest) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.post(`${config.appBaseUrl}/reviewer/grant?applicationId=${modifiedAppId}`, data)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  assignButtonStatusReviewer: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/assign-button-check?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  autoAssign: () => {
    return Axios.post(`${config.appBaseUrl}/reviewer/auto-assign-me`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  assignToMe: ({ applicationId }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.post(`${config.appBaseUrl}/reviewer/assign-me?applicationId=${modifiedAppId}`, {})
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  unassignToMe: ({ applicationId }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.put(`${config.appBaseUrl}/reviewer/un-assign?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  cancelReturn: ({ applicationId }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.post(`${config.appBaseUrl}/reviewer/cancel-returned-application?applicationId=${modifiedAppId}`, {})
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  cancelDecline: ({ applicationId }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.post(`${config.appBaseUrl}/reviewer/cancel-rejected-application?applicationId=${modifiedAppId}`, {})
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  reviewSubmitApplication: (data: ReviewSubmitApplicationRequest) => {
    const { applicationId, ...restData } = data;
    return Axios.post(
      `${config.appBaseUrl}/associate/application/survey-and-review?applicationId=${applicationId}`,
      restData
    )
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  approveButtonCheck: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/validate-button?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  approveGrantRequest: ({ applicationId, totalAmountApproved }: ApproveGrantPayload) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.post(`${config.appBaseUrl}/reviewer/approve-application?applicationId=${modifiedAppId}`, {
      totalAmountApproved: totalAmountApproved.toFixed(2),
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getDocsForHardship: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/hardship-documents?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getDocsForGrant: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/grant-documents?applicationId=${modifiedAppId}`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getViewLogs: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/application-logs?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  exportActivityLog: (applicationId) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/application-logs/export`, {
      params: { applicationId: modifiedAppId },
      responseType: 'blob',
    })
      .then((res) => ({
        blob: res.data,
        contentDisposition: res.headers?.['content-disposition'],
      }))
      .catch((error) => exceptionHandler(error));
  },
  getViewLogsAssociate: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/associate/application/application-logs?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getCommunicationContent: (communicationId: string) => {
    return Axios.get(`${config.appBaseUrl}/emailarchive/${communicationId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  rejectButtonCheck: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/reject-button-check?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  cancelReturnButtonCheck: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/cancel-return-button-check?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  cancelDeclineButtonCheck: ({ queryKey }: any) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/cancel-reject-button-check?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getApplicantHardshipEventDetails: ({ queryKey }: any): Promise<IHardshipEventDetails> => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/hardship/eventDetails?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  reviewerRejectApplication: ({ applicationId, data }) => {
    return Axios.post(`${config.appBaseUrl}/reviewer/reject-application?applicationId=${applicationId}`, data)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAvailableReviewers: () => {
    return Axios.get(`${config.appBaseUrl}/reviewer/dashboard/filters`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAssociateApplicationProgress: (applicationId) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.get(`${config.appBaseUrl}/associate/application/progress?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  cancelAssociateApplication: (applicationId) => {
    return Axios.post(`${config.appBaseUrl}/associate/application/cancel?applicationId=${applicationId}`, {})
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  returnApplicationToApplicant: ({ applicationId }) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(applicationId);
    return Axios.post(`${config.appBaseUrl}/reviewer/return-application?applicationId=${modifiedAppId}`, {})
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getReviewerValidActions: ({ queryKey }) => {
    const modifiedAppId = cleanupPrefixFromApplicationId(queryKey[1].applicationId);
    return Axios.get(`${config.appBaseUrl}/reviewer/get-actions?applicationId=${modifiedAppId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  downloadReviewerDashboard: (data) => {
    // Backend generates the report asynchronously and emails a download link --
    // this now just kicks off the job (202 Accepted, empty body), it does NOT
    // return a file. See acnt-ws AdminDetailedExcelExportService-style async export.
    return Axios.post(`${config.appBaseUrl}/reviewer/dashboard/download`, data)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getSavingsConfiguration: () => {
    return Axios.get(`${config.appBaseUrl}/associate/application/savings-configuration`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getSavedFilters: () => {
    return Axios.get(`${config.appBaseUrl}/reviewer/dashboard/fetch-filters`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  setSavedFilters: (filters: SavedFiltersInputs) => {
    return Axios.post(`${config.appBaseUrl}/reviewer/dashboard/save-filters`, filters)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  deleteFilters: (filterId: string) => {
    return Axios.delete(`${config.appBaseUrl}/reviewer/dashboard/delete-filters?filterId=${filterId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  updateDefaultFilter: (data: DefaultFilter) => {
    return Axios.post(`${config.appBaseUrl}/reviewer/dashboard/update-default-filter`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getInternalComments: (applicationId) => {
    return Axios.get(`${config.appBaseUrl}/reviewer/fetch-internal-comments?applicationId=${applicationId}`)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  setInternalComments: (internalCommentsInput) => {
    return Axios.post(`${config.appBaseUrl}/reviewer/post-internal-comments`, internalCommentsInput)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  downloadAssociateFiles: (params) => {
    return Axios.get(`${config.appBaseUrl}/associate/application/documents`, { params, responseType: 'blob' })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  downloadReviewerFiles: (params) => {
    return Axios.get(`${config.appBaseUrl}/reviewer/document-download`, { params, responseType: 'blob' })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },

  downloadHardshipAdminFiles: (params) => {
    return Axios.get(`${config.appBaseUrl}/associate/application/sample-hardship-document`, {
      params,
      responseType: 'blob',
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  downloadGrantAdminFiles: (params) => {
    return Axios.get(`${config.appBaseUrl}/associate/application/sample-grant-document`, {
      params,
      responseType: 'blob',
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  resetHardshipGrants: ({ applicationId }) => {
    return Axios.delete(
      `${config.appBaseUrl}/associate/application/reset-hardship-and-grants?applicationId=${applicationId}`
    )
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  resetGrantDocuments: ({ applicationId, grantId }) => {
    return Axios.delete(`${config.appBaseUrl}/associate/application/reset-grants`, {
      params: { applicationId, grantId },
    })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  disasterConfiguredAmount: () => {
    return Axios.get(`${config.appBaseUrl}/disaster/configured-amount`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveApplicationGrantRequestDisasterDetails: (payload) => {
    const { applicationId, disasterGrantRequest } = payload;
    return Axios.post(`${config.appBaseUrl}/associate/disaster-application/grant`, disasterGrantRequest, {
      params: { applicationId },
    })
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  disasterCountyListByStateCode: (data) => {
    return Axios.post(`${config.appBaseUrl}/county`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveDisasterEvent: (data) => {
    return Axios.post(`${config.appBaseUrl}/disaster`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  addDisasterCounty: (data) => {
    return Axios.post(`${config.appBaseUrl}/disaster/add-counties`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  saveExitApplicationGrantRequestDisasterDetails: (payload) => {
    return Axios.post(`${config.appBaseUrl}/associate/application/save-and-exit`, payload)
      .then((res) => res.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  getAllDisastersData: () => {
    return Axios.get(`${config.appBaseUrl}/disaster/all?active=true`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  generateExcelReportAdmin: (data) => {
    return Axios.post(`${config.appBaseUrl}/generate-detailed-report`, data, { responseType: 'blob' })
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  generateD2CReportAdmin: (data) => {
    return Axios.post(`${config.appBaseUrl}/generate-D2C-report`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  ResubmittedApplicationCount: (data) => {
    return Axios.post(`${config.appBaseUrl}/getResubmittedApplicationCount`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  generateReconReportAdmin: (data) => {
    return Axios.post(`${config.appBaseUrl}/financial-reports/recon-report`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  generateOutstandingReportAdmin: (data) => {
    return Axios.post(`${config.appBaseUrl}/financial-reports/outstanding`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  ApplicationCountMetrics: (data) => {
    return Axios.post(`${config.appBaseUrl}/getApplicationCount`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  AllActiveUser: (data) => {
    return Axios.post(`${config.appBaseUrl}/getAllActiveUser`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  PaymentStatusCount: (data) => {
    return Axios.post(`${config.appBaseUrl}/paymentStatusCount`, data)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
  GetFeatureFlagDetails: () => {
    return Axios.get(`${config.appBaseUrl}/featureFlags`)
      .then((response) => response.data)
      .catch((error) => {
        exceptionHandler(error);
      });
  },
};

export default ACNTService;
